import Route from '@ember/routing/route';

export default class AuthenticatedPslfDashboardForgivenessEstimatorResultsIndexRoute extends Route {
  model() {
    return this.modelFor('authenticated.pslf.dashboard.forgiveness-estimator.results');
  }
}
